"use client";
import dynamic from "next/dynamic";
import { Box } from "@mui/material";
const Search = dynamic(() => import("@/_components/Search/Search"), {
  ssr: false,
});
export default function SearchPage() {
  return (
    <Box
      sx={{
        flex: 1,
        width: "100%",
        px: 2,
        pt: 4,
        pb: 0,
        bgcolor: "whitesmoke",
      }}
    >
      <Search />
    </Box>
  );
}
